import {
  useCrearCodigoSobres,
  useListarCodigos,
  useListarObjetos,
  useListarGrados
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  camposFilter,
} from "./camposFormulario";
import { useEffect, useState } from "react";

export const CodigosSobresForm = () => {
  const [campos, setCampos] = useState(camposFormulario([]));
  const initialValues = {
    cantidad: 1,
  };
  const queryListarObjetos = useListarObjetos([]);
  const queryListarGrados = useListarGrados([]);

  useEffect(() => {
    if (queryListarObjetos.data && queryListarGrados.data) {
      setCampos(camposFormulario(queryListarObjetos?.data, queryListarGrados?.data));
    }
  }, [queryListarObjetos.isSuccess, queryListarGrados.isSuccess]);

  return (
    <>
      {campos && (
        <CustomForm
          camposFormulario={campos}
          querySubmit={useCrearCodigoSobres}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export const CodigosSobresEditar = () => {
  const [campos, setCampos] = useState(camposFilter([]));
  
  const queryListarGrados = useListarGrados([]);
  const initialValues = {
    mostrarUsados: 0,
  };

  useEffect(() => {
    if (queryListarGrados.isSuccess) {
      const estados = [
        {
          label: "Activos",
          value: 0,
        },
        {
          label: "Mostrar Todo",
          value: 1,
        },
      ];
      setCampos(camposFilter(estados, queryListarGrados?.data));
    }
  }, [queryListarGrados.isSuccess]);

  return (
    <CustomTable
      camposFilter={campos}
      queryListar={useListarCodigos}
      columns={columns}
      initialValues={initialValues}
    />
  );
};
